import React, { useEffect, useState } from 'react';
import PageLayout from '../layouts/PageLayout';
import { MainData } from '../data/MainData';
// import {  useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
// import { prefixer } from 'stylis';
import { GetDataPromise } from "../Functions/SendingData";
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import createCache from '@emotion/cache';
// import { Loading } from "../Loading";
// import rtlPlugin from 'stylis-plugin-rtl';
import { apiMain } from "../../App";
import LoadingOverlay  from "../LoadingOverlay";
import { Room_Home } from "../images/Room_Home";

import Reservation from './Reservation';

import mback from "../images/Back.png";
import CheckIn from './CheckIn';
import { RoomCard } from './RoomCard';
import RoomFee from '../menus/RoomFee';
import MyAppBar from '../layouts/MyAppBar';

import CheckOut from './CheckOut';
// import { useRowState } from 'react-table';
//import { permission } from 'process';
const Styles = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 50%;
  background-image: "../images/Back.png";    
  .flex-container {
      display: flex;
      Flex-direction: row;
      flex-flow: row wrap;
      margin-left: 50px;

      gap:50px;
  }
  .flex-items {
          //  background-color: #f4f4f4;
            width: 4100px;
           height: 350px;
           margin: 10px;
           display: flex;
        //    text-align: center;
            font-size: 40px;
        }
        .flex-items-Cards {
          //  background-color: #f4f4f4;
            width: 900px;
           height: 350px;
        //   margin: 10px;
           display: block;
        //    text-align: center;
            font-size: 40px;
          //  margin: 1vh auto 0;

        }
        .flex-items-Rooms {
          //  background-color: #f4f4f4;
            width: 50vw;
           height: 90vh;
           margin: 10px;
           display: flex;
    
          justify-content:center;
 
            font-size: 40px;
            margin: 5vh auto 0;
            margin-left:420px;
        }
      
        /* @media (max-width:850px){
       .flex-items-Cards{
            width: 900px;
           height: 350px;
        //   margin: 10px;
           display: flex;
        //    text-align: center;
            font-size: 40px;
         //   margin: 150vh auto 0;
            margin-top:5px;
            background-color:yellow;
          }
        }   */
         @media (max-width:850px){
          .flex-items-Rooms{
            width: 100vw;
            height: 100vh;
            margin: -18vh -5vh 0;
        //  background-color:yellow;
          }
   
        }
/*
@media (max-width:1024px){
          .flex-items-Rooms{
            width: 659px;
           height: 641px;
           background-color:green;
} */
 // justify-content: flex-start | flex-end | center | space-between | space-around;

  .main-slide{
     position: relative;
      top: 0;
      bottom: 0;
      right: 0;
      left: 0;
   //   background-image:url("${mback}")   
    //  background-color:red;
  //  background-image:"../images/Back.png";
//   background-image:"url('https://media.geeksforgeeks.org/wp-content/uploads/rk.png')";

    //  z-index:95000;
   //  background-color:yellow;
   //   color:white;
     transition: all 0.3s ease-in-out;
     /* &:hover {
               
                  
                    cursor: pointer;
               
            } */

      img {
       
          width: 100%;
           height: 290px; 
          object-fit: cover;
          display: block;
          overflow: hidden;
        //  background-color:black;
      //  background-image:"url('https://media.geeksforgeeks.org/wp-content/uploads/rk.png')";
 
       aspect-ratio: 1450 / 497;
      };
      .rect {

    width: 205px;
     height: 287px; 
    object-fit: none;
    display: block;
    overflow: hidden;
    background-color:white;
   
 aspect-ratio: 287 / 205;
};
      .zan {
     //   padding-top:200px;
             width: 100px;
           height: 100px; 
          object-fit:cover;
          display: flex;
          overflow: visible;
      //   aspect-ratio: 1450 / 497;
      }
      .zany {
     //   padding-top:200px;
             //   fill: yellow;
             width: 100px;
           height: 100px; 
          object-fit:cover;
          display: flex;
          overflow: visible;
      //    background-color:black;

      //   aspect-ratio: 1450 / 497;
      }
      .labely{
        color:yellow;
        display: flex;
      
      }
      .labelw{
       // align-items:left;
       // display:flex;
        
        text-align:left
      }
    }
`
function Home(props) {

 //  const [mojavez, setmojavez] = useState([]);
//  const location = useLocation();
//  const { user } = props;
  const [data, setData] = useState();
  const [mflag, setMflag] = useState(false);
  const [Color, setColor] = useState([]);
  const [Permission, setPermission] = useState([]);
  const [Xpage, setXpage] = useState(0);
  // const [dialogOpen1, setDialogOpen1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [RoomSetting, setRoomSetting] = useState(false);
  const [Room_Number, setRoom_Number] = useState(0);
  const [Ucount, setUcount] = useState(0);
  const [restflag, setRestflag] = useState(false);
  const [Reserv_Id, setReserv_Id] = useState(0);
  const [selectedDate, setSelectedDate] = useState(new Date());

const onChangeDate = (e) => {
    setSelectedDate(e);
  //  GetData(e.year, e.month, e.day); // آپدیت دیتا
};
  const getpermission = async () => {
    setLoading(true);
    let uparams = new URLSearchParams();
    uparams.append("U_Id", localStorage.getItem('U_id'));
  
    let res = await GetDataPromise(`${apiMain}/api/v1/permission/select?${uparams}`, true);
    let parsed = JSON.parse(res);
  
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
      setPermission(newData);
      setLoading(false);
      return newData; // 👈 حتماً مقدار را برگردان
    } else {
      setLoading(false);
      return null;
    }
  };
  
  const getData = async (y, m, d) => {
    let uparams = new URLSearchParams();
    setLoading(true)
    // { <Loading small={true} /> }
    if (y === 0) {

      let today = new Date();
      let mon = 0;

      mon = today.getMonth();
      mon = mon + 1;
      m = mon;
      y = today.getFullYear();
      d = today.getDate();
    }

    let indate = y + '-' + m + '-' + d;

    uparams.append("Checkdate", indate);
    let res = await GetDataPromise(`${apiMain}/api/v1/reservation/roomcheckdate?${uparams}`, false);

    let parsed = JSON.parse(res);
    if ((parsed.status && parsed.status !== "error") || parsed.status === "success") {
      let newData = parsed.data;
   
      setData(prev => {
        return {
          ...prev,
          attr: newData
        }
      })
      ClearZanBouri()
 
      newData.forEach((nd) => {
        let room_no = 0;
        let Reserv_Type = 0;
        room_no = nd['Room_Number']
        Reserv_Type = nd['Reserv_Type']
        let nom = 0;
        if (room_no < 200)
        {
 nom = room_no - 102;
        //  alert(room_no + '====' + nom + '=====' + Reserv_Type)

        } 
        if (room_no > 200 && room_no < 300)
          nom = room_no - 197;
        if (room_no > 300)
          nom = room_no - 292;
             console.log(nom);
        setColor(prev => {
          let temp = prev
       
          switch (Reserv_Type) {
            case 1:
              temp[nom] =  '#F4F754' //زرد

              break;
            case 2:
              temp[nom] ='#F2595C' //'#5F8C5F'قرمز

              break;
            default:
              temp[nom] = '#5F8C5F'//'#A6D9EF'
              break;
          }

          // { <Loading small={true} /> }

          return temp;

        })

      })



    }
    setLoading(false)
  }
  
      useEffect(() => {
      const fetchData = async () => {
          try {
            const newData = await getpermission();
            console.log("permission data:", newData);
          } catch (err) {
            console.error(err);
          }
      
      

      // بقیه کارها فقط بعد از گرفتن permission انجام می‌شن
      setColor(Color, []);
      localStorage.setItem('white', "#43b910");
      localStorage.setItem('yellow', '#E1C14B');
      localStorage.setItem('red', 'red');
      localStorage.setItem('Reserv_Id', 0);
  
      let y = 0;
      let m = 0;
      let d = 0;
      await getData(y, m, d); // حتی بهتره این هم await باشه
    };
  
   fetchData();
  }, []);

  function changeUcount() {
    setUcount((prev) => prev + 1)
  }
  function ChangeXpage(e) {
    setXpage(e)
  }

  function changeRestFlag(e) {
    setRestflag(e)
  }

  
  // const cacheRtl = createCache({
  //   key: 'muirtl',
  //   stylisPlugins: [prefixer, rtlPlugin],
  // });
  // const customPlugin = () => { }
  // const myCache = createCache({
  //   key: 'my-prefix-key',
  //   stylisPlugins: [
  //     customPlugin,
  //     // has to be included manually when customizing `stylisPlugins` if you want
  //     // to have vendor prefixes added automatically
  //     prefixer
  //   ]
  // })
  // const closeFunc1 = () => {
  //   //  setDialogData1(false)
  //   setDialogOpen1(false)
  // }

  function ZanNumb(e) {
    setRoomSetting(e)
    //  setDialogOpen1(true)

  };
  function flageckeck(tf) {
    setMflag(tf);
  }
  function changeRoom_Number(rn) {
    setRoom_Number(rn)
    setRestflag(false);
    localStorage.setItem('Reserv_Id', 0)
  }

  function ClearZanBouri() {
    setColor(Color, []);
  //  setColor(["#A6D9EF"]);
    setColor(["#5F8C5F"]);
    
    setRestflag(false);
    localStorage.setItem('Reserv_Id', 0)
    for (let index = 0; index < 16; index++) {
      setColor((Color) => ([
        ...Color,
        "#5F8C5F"
      ]));

    }

  }
  // function LoadPopup() {

    //  switch (RoomOrHome) {
    //   case 1:

    //     <PopupMain />

    //   break;
    //   case 2:
    //     <PopupMain />

    //   case 5: 

    //       break;

    //   default :
    //     break;
    //  }

  // };
  // function MouseOver(event) {

  //   // event.target.style.background = 'red';
  // }
  // function MouseOut(event) {

  // }
  let hei1 = window.innerHeight * 641 / 746;
  // let wid1 = window.innerWidth * 659 / 1528;
  let wid = window.innerWidth;
  let hei = window.innerHeight;
  // let Room_wid = '';
  let Room_hei = '';
  //  if ( wid > hei ){

  //    Room_wid=(wid/2 -(wid*659/1528)/2)+ 'px' ;
  //   Room_hei=  (hei/2 -(hei*641/746) /2+20)+ 'px' ;
  //  }
  //  else
  //  {
  //    Room_wid=(wid/2 -(wid*659/1528))+ 'px' ;
  //   Room_hei=  (hei/2 -(hei*641/746) /2)+ 'px' ;
  //  }
 // Room_wid = (wid / 2 - (wid * 659 / 1528) / 2) + 'px';
  Room_hei = (hei / 2 - (hei * 641 / 746) / 2 + 20) + 'px';
  // let nf = 'en'
  // let navigate = useNavigate();
  // let sflag = mflag;
  // let dis = 'none';
  // if (mflag) { dis = 'display' }
 // else { dis = 'none' }

  const SetRoom = () => {
    return (
      <Dialog
        open={RoomSetting}
        onClose={() => ZanNumb(false)}
        PaperProps={{
          sx: {
            maxWidth: 1000,
            maxHeight: 700,
            width: 1500,
            height: 1500,
            backgroundColor: '#F2F2F2'
          },
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            // ZanNumb(false);
          },
        }}
      >
        <DialogTitle>Setting</DialogTitle>
        <DialogContent>
          <DialogContentText>

          </DialogContentText>
          <RoomFee Room_No={Room_Number} />

        </DialogContent>
        <DialogActions    >
          <Stack direction="row" spacing={1} style={{ paddingRight: '400px' }}>
            <Chip label="Exit" color="primary" onClick={() => ZanNumb(false)} sx={{ width: 150, cursor: 'pointer' }} />
          </Stack>


        </DialogActions>
      </Dialog>
    )
  }
  //  let dis =sflag ? 'display': 'none';
  const renderPage = () => {
    
  switch (Xpage) {
    case 0:

      if (loading) {
       // { <Loading small={true} /> }
         <LoadingOverlay isLoading={loading} text="Loading data..." />
      }
      else
        return (

          <PageLayout
            {...props}
            language="en" //{lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
            dict={MainData.dict}
            mainLogo={MainData.mainLogo}
            texts={MainData.texts}
            nav={MainData.nav}
            footer={MainData.footer}
            login={MainData.login}
            zannumb={ZanNumb}
            ClearZan={ClearZanBouri}
            GetData={getData}
            Mojavez={Permission}
            onChangeDate={onChangeDate}
            selectedDate={selectedDate}
          >

            {/* <MyAppBar  mainLogo={MainData.mainLogo}  zannumb={ZanNumb} /> */}
            {/* <Styles >
              <div className="flex-container" >
                {mflag ?
                  /* style={{marginTop:Room_hei,height:hei1}}
                  <div className='flex-items' style={{ marginTop: Room_hei, height: hei1 }}  > 
                    <RoomCard permission={Permission} getcolordata={getData} Flageckeck={flageckeck} Room_Number={Room_Number} Ucount={Ucount} restflag={restflag} changeRestFlag={changeRestFlag} ChangeXpage={ChangeXpage} />
                  </div>
                  : <div className='flex-items' style={{ marginTop: Room_hei, height: hei1 }}    >
                    <RoomCard permission={Permission} getcolordata={getData} Flageckeck={flageckeck} ChangeXpage={ChangeXpage} />
                  </div>}
                {/* <div className="flex-items" style={{marginLeft:Room_wid,marginTop:Room_hei,width:wid1,height:hei1,display:'flex'}}>
                <div className="flex-items-Rooms"
                /* style={{marginLeft:Room_wid,marginTop:Room_hei}}  
                >
                  {/* <div className="main-slide"  >  
                  {/* <Room_No  Mflag={mflag} Flageckeck={flageckeck} changeRoom_Number={changeRoom_Number} changeUcount={changeUcount}  color={Color} style={{width:528, height:443}}/>  
                  <Room_Home Mflag={mflag} Flageckeck={flageckeck} changeRoom_Number={changeRoom_Number} changeUcount={changeUcount} color={Color} />

                  {/* </div>  
                </div>
              </div>
              {SetRoom()}

            </Styles> */}
            <Styles >

              <div className="flex-container" >

            <div className="flex-items-Rooms" >
             <Room_Home Mflag={mflag} Flageckeck={flageckeck} changeRoom_Number={changeRoom_Number} changeUcount={changeUcount} color={Color} /> 
                 </div> 
                {mflag ?
                 <div className="flex-items-Cards" >
                    <RoomCard  permission={Permission} getcolordata={getData} Flageckeck={flageckeck} Room_Number={Room_Number} Ucount={Ucount} restflag={restflag} changeRestFlag={changeRestFlag} ChangeXpage={ChangeXpage} />
               </div>
                 : 
             <></>
                  }
           
</div>  
 {SetRoom()}
            </Styles>
          </PageLayout>
          // </>
        )
      break;
    case 1:
      return (
        <PageLayout
          {...props}
          language="en" //{lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
          dict={MainData.dict}
          mainLogo={MainData.mainLogo}
          texts={MainData.texts}
          nav={MainData.nav}
          footer={MainData.footer}
          login={MainData.login}
          zannumb={ZanNumb}
          ClearZan={ClearZanBouri}
          GetData={getData}
          Mojavez={Permission}
          onChangeDate={onChangeDate}
          selectedDate={selectedDate}
        >

          {/* <MyAppBar  mainLogo={MainData.mainLogo}  /> */}
          <Styles >
            <div className="flex-container" >
              {/* {mflag ? 
              <div className='flex-items' style={{marginTop:'100px',display:'flex'}}  >  
              

               <RoomCard Flageckeck={flageckeck}  Room_Number={Room_Number}  Ucount={Ucount} restflag={restflag} changeRestFlag={changeRestFlag} ChangeXpage={ChangeXpage}/>      

             </div>
             :  <div className='flex-items'  style={{marginTop:'100px'}}  > 
                <RoomCard Flageckeck={flageckeck} ChangeXpage={ChangeXpage}/>
             </div> } */}
              <div className="flex-items" style={{ marginTop: mflag ? '-100px' : '20px', marginLeft: wid / 5 + 10 + 'px', display: 'flex' }}>
                <div className="main-slide" style={{ marginTop: '0px' }} >
                  {/* <Room_No  Mflag={mflag} Flageckeck={flageckeck} changeRoom_Number={changeRoom_Number} changeUcount={changeUcount}  color={Color} style={{width:528, height:443}}/> */}
                  <Reservation Room_No={Room_Number} ChangeXpage={ChangeXpage} kk={2} />
                </div>
              </div>
            </div>
            {SetRoom()}
          </Styles>
        </PageLayout>
        // </>
      )
    //  break;
    case 2:
      return (
        <PageLayout
          {...props}
          language="en" //{lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
          dict={MainData.dict}
          mainLogo={MainData.mainLogo}
          texts={MainData.texts}
          nav={MainData.nav}
          footer={MainData.footer}
          login={MainData.login}
          zannumb={ZanNumb}
          ClearZan={ClearZanBouri}
          GetData={getData}
          Mojavez={Permission}
          onChangeDate={onChangeDate}
          selectedDate={selectedDate}
        >

          <MyAppBar mainLogo={MainData.mainLogo} />
          <Styles >
            <div className="flex-container" >
              {mflag ?
              // style={{ marginTop: Room_hei, height: hei1 }}
                <div className='flex-items-Cards'   >
                  <RoomCard Flageckeck={flageckeck} Room_Number={Room_Number} Ucount={Ucount} restflag={restflag} changeRestFlag={changeRestFlag} ChangeXpage={ChangeXpage} />
                </div>
                // style={{ marginTop: Room_hei, height: hei1 }}
                : <div className='flex-items-Cards'  >
                  <RoomCard Flageckeck={flageckeck} ChangeXpage={ChangeXpage} />
                </div>}
              <div className="flex-items" style={{ marginTop: mflag ? '-100px' : '20px', marginLeft: '300px', display: 'flex' }}>
                <div className="main-slide" style={{ marginTop: '0px' }} >
                  {/* <Room_No  Mflag={mflag} Flageckeck={flageckeck} changeRoom_Number={changeRoom_Number} changeUcount={changeUcount}  color={Color} style={{width:528, height:443}}/> */}
                  <CheckIn Room_No={Room_Number} ChangeXpage={ChangeXpage} />

                </div>
              </div>
            </div>
            {SetRoom()}
          </Styles>
        </PageLayout >
        // </>
      )
   //   break;
    case 3:
      return (
        <PageLayout
          {...props}
          language="en" //{lan ? {...MainData.dict[0]} : {...MainData.dict[1]}} 
          dict={MainData.dict}
          mainLogo={MainData.mainLogo}
          texts={MainData.texts}
          nav={MainData.nav}
          footer={MainData.footer}
          login={MainData.login}
          zannumb={ZanNumb}
          ClearZan={ClearZanBouri}
          GetData={getData}
          Mojavez={Permission}
          onChangeDate={onChangeDate}
          selectedDate={selectedDate}
        >

          <MyAppBar mainLogo={MainData.mainLogo} />
          <Styles >
            <div className="flex-container" >
              {mflag ?
              //  style={{ marginTop: Room_hei, height: hei1 }}
                <div className='flex-items-Cards'  >
                  <RoomCard Flageckeck={flageckeck} Room_Number={Room_Number} Ucount={Ucount} restflag={restflag} changeRestFlag={changeRestFlag} ChangeXpage={ChangeXpage} />
                </div>
                //  style={{ marginTop: Room_hei, height: hei1 }} 
                : <div className='flex-items-Cards' style={{ marginTop: Room_hei, height: hei1 }}  >
                  <RoomCard Flageckeck={flageckeck} ChangeXpage={ChangeXpage} />
                </div>}
              <div className="flex-items" style={{ marginTop: mflag ? '-100px' : '20px', marginLeft: '300px', display: 'flex' }}>
                <div className="main-slide" style={{ marginTop: '100px' }} >
                  {/* <Room_No  Mflag={mflag} Flageckeck={flageckeck} changeRoom_Number={changeRoom_Number} changeUcount={changeUcount}  color={Color} style={{width:528, height:443}}/> */}

                  <CheckOut Room_No={Room_Number} reserv_id={Reserv_Id} ChangeXpage={ChangeXpage} />
                </div>
              </div>
            </div>
            {SetRoom()}
          </Styles>
        </PageLayout>
        // </>
      )
  //    break;
    default:
      <div>خطا</div>
 

      break;
  };

}
return renderPage();  // ← این مهمه!
}
export default Home
